import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Leaf, Zap, Cloud, Droplets } from "lucide-react";

export default function GreenKmSavedCard({ className = "" }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/reports/green-km-saved").then(({ data }) => setData(data)).catch(() => setData({ vehicles: [], totals: {} }));
  }, []);

  if (!data) return null;
  const totals = data.totals || {};
  if (!data.vehicles || data.vehicles.length === 0) {
    return (
      <div className={`border border-[color:var(--border-line,#262626)] bg-[color:var(--bg-surface,#121212)] p-5 ${className}`} data-testid="green-km-empty">
        <div className="flex items-center gap-2 mb-1">
          <Leaf size={18} className="text-emerald-400" />
          <span className="ft-overline text-xs">GREEN KM SAVED</span>
        </div>
        <div className="text-sm text-[color:var(--text-secondary,#A3A3A3)]">
          Add an EV or PHEV vehicle and log a charging session to see fuel + CO₂ saved.
        </div>
      </div>
    );
  }
  return (
    <div className={`border border-[color:var(--border-line,#262626)] bg-[color:var(--bg-surface,#121212)] ${className}`} data-testid="green-km-card">
      <div className="px-5 py-3 border-b border-[color:var(--border-line,#262626)] flex items-center gap-2">
        <Leaf size={18} className="text-emerald-400" />
        <span className="font-display text-lg font-black tracking-tight">Green km saved</span>
        <span className="ft-overline text-[10px] text-[color:var(--text-tertiary,#737373)] ml-auto">
          vs. {data.baseline_kmpl || 18} km/l petrol baseline
        </span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[color:var(--border-line,#262626)]">
        <div className="bg-[color:var(--bg-surface,#121212)] p-4">
          <div className="ft-overline text-[10px]">KM (ELECTRIC)</div>
          <div className="font-display text-3xl font-black tabular-nums">{Math.round(totals.km || 0)}</div>
        </div>
        <div className="bg-[color:var(--bg-surface,#121212)] p-4">
          <div className="ft-overline text-[10px] flex items-center gap-1"><Zap size={10} /> kWh</div>
          <div className="font-display text-3xl font-black tabular-nums">{Math.round(totals.kwh || 0)}</div>
        </div>
        <div className="bg-[color:var(--bg-surface,#121212)] p-4">
          <div className="ft-overline text-[10px] flex items-center gap-1"><Droplets size={10} /> LITRES SAVED</div>
          <div className="font-display text-3xl font-black tabular-nums">{Math.round(totals.litres_saved || 0)}</div>
        </div>
        <div className="bg-[color:var(--bg-surface,#121212)] p-4">
          <div className="ft-overline text-[10px] flex items-center gap-1"><Cloud size={10} /> KG CO₂</div>
          <div className="font-display text-3xl font-black tabular-nums text-emerald-400">{Math.round(totals.co2_kg_saved || 0)}</div>
        </div>
      </div>
      {totals.money_saved !== undefined && (
        <div className="px-5 py-3 text-sm text-[color:var(--text-secondary,#A3A3A3)]">
          Estimated ₹{Math.round(totals.money_saved).toLocaleString("en-IN")} saved on fuel across your EV fleet.
        </div>
      )}
      <div className="px-5 pb-4 space-y-1">
        {data.vehicles.map((v) => (
          <div key={v.vehicle_id} className="flex items-center justify-between text-xs">
            <span className="text-[color:var(--text-tertiary,#737373)] font-mono">{v.number}</span>
            <span className="text-[color:var(--text-secondary,#A3A3A3)]">{v.name}</span>
            <span className="text-emerald-400 tabular-nums">{Math.round(v.co2_kg_saved)} kg CO₂ ↓</span>
          </div>
        ))}
      </div>
    </div>
  );
}
